import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMusic, faBook, faShieldAlt, faHeartbeat, faSearch } from '@fortawesome/free-solid-svg-icons';
import styles from '../css/comuns/CardsEntretenimento.module.css';
import { config } from '../../data';

const OfferCard = ({ logo, name, banner, price, description, id }) => {
  // Busca as imagens dinâmicas baseadas no id (deezer, duolingo, etc.)
  const getCardImage = (cardId, type) => {
    if (cardId === 'deezer' && config.images.entretenimento.deezer) {
      return type === 'logo' ? config.images.entretenimento.deezer.logo : config.images.entretenimento.deezer.banner;
    }
    // Fallback para imagens passadas como prop
    return type === 'logo' ? logo : banner;
  };

  return (
    <div className={styles['card-manual']}>
      <div className={styles['d-flex']}>
        <div className={styles['logo-manual']}>
          <img alt={`${name} logo`} className={styles['logo-img-manual']} src={getCardImage(id, 'logo')} />
        </div>
        <div className={styles['logo-text-manual']}>
          <span className={styles['text-primary']}>{name}</span>
        </div>
      </div>
      <div className={styles['card-container']}>
        <div className={styles['card-content-manual']}>
          <img alt="" className={styles['card-image-manual']} src={getCardImage(id, 'banner')} />
          <div className={styles['text-center']}>
            <span className={styles['text-secondary']}>R$</span>
            <span className={styles['fs-4']}>{price}</span>
            <span className={styles['text-secondary']}>/mês*</span>
          </div>
          <div className={styles['text-center']}>
            <button className={styles['btn-primary']}>{config.texts.cardsEntretenimento.buttons.saibaMais}</button>
          </div>
          <div className={styles['text-center']}>
            <small>{config.texts.cardsEntretenimento.buttons.consultar}</small>
          </div>
        </div>
        <div className={styles['description-container']}>
          <p className={styles['description-text']}>
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

const CardsEntretenimento = () => {
  const categories = [
    { id: 'streaming-musica', name: config.texts.cardsEntretenimento.categorias.streamingMusica, icon: faMusic },
    { id: 'educacao', name: config.texts.cardsEntretenimento.categorias.educacao, icon: faBook },
    { id: 'seguranca-digital', name: config.texts.cardsEntretenimento.categorias.segurancaDigital, icon: faShieldAlt },
    { id: 'saude-bem-estar', name: config.texts.cardsEntretenimento.categorias.saudeBemEstar, icon: faHeartbeat },
  ];

  const offers = {
    streamingMusica: config.content.cardsEntretenimento.streamingMusica,
    educacao: config.content.cardsEntretenimento.educacao,
    segurancaDigital: config.content.cardsEntretenimento.segurancaDigital,
    saudeBemEstar: config.content.cardsEntretenimento.saudeBemEstar,
  };

  return (
    <div>
      <header className={styles['header-cards']}>
        <nav className={styles['navegacao']}>
          <div className={styles['container']}>
            <div className={styles['categories-wrapper']}>
              {categories.map((category) => (
                <a key={category.id} href={`#${category.id}`} className={styles['category-btn']}>
                  <FontAwesomeIcon icon={category.icon} className={styles['category-icon']} />
                  <span>{category.name}</span>
                </a>
              ))}
            </div>
            <div className={styles['search-wrapper']}>
              <div className={styles['search-bar']}>
                <input type="text" className={styles['form-control']} placeholder="Digite a sua busca aqui" />
                <button className={styles['search-btn']} type="button">
                  <FontAwesomeIcon icon={faSearch} className={styles['search-icon']} />
                  <span>Buscar</span>
                </button>
              </div>
            </div>
          </div>
        </nav>
      </header>

      <main>
        <section className={styles['streaming-musica']}>
          <div className={styles['section-headline']}>
            <div className={styles['container']}>
              <h2 id="streaming-musica">Streaming e Música</h2>
              <p>Descubra o melhor em entretenimento musical e serviços de streaming</p>
            </div>
          </div>
          <div className={styles['container']}>
            <div className={styles['row']}>
              {offers.streamingMusica.map((offer, index) => (
                <div key={index} className={styles['col-lg-3']}>
                  <OfferCard {...offer} />
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className={styles['educacao']}>
          <div className={styles['section-headline']}>
            <div className={styles['container']}>
              <h2 id="educacao">Educação</h2>
              <p>Expanda seus horizontes com cursos e recursos educacionais de alta qualidade</p>
            </div>
          </div>
          <div className={styles['container']}>
            <div className={styles['row']}>
              {offers.educacao.map((offer, index) => (
                <div key={index} className={styles['col-lg-3']}>
                  <OfferCard {...offer} />
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className={styles['seguranca-digital']}>
          <div className={styles['section-headline']}>
            <div className={styles['container']}>
              <h2 id="seguranca-digital">Segurança Digital</h2>
              <p>Proteja sua presença online com as melhores soluções de segurança digital</p>
            </div>
          </div>
          <div className={styles['container']}>
            <div className={styles['row']}>
              {offers.segurancaDigital.map((offer, index) => (
                <div key={index} className={styles['col-lg-3']}>
                  <OfferCard {...offer} />
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className={styles['saude-bem-estar']}>
          <div className={styles['section-headline']}>
            <div className={styles['container']}>
              <h2 id="saude-bem-estar">Saúde e Bem-Estar</h2>
              <p>Cuide do seu corpo e mente com aplicativos focados em saúde e bem-estar</p>
            </div>
          </div>
          <div className={styles['container']}>
            <div className={styles['row']}>
              {offers.saudeBemEstar.map((offer, index) => (
                <div key={index} className={styles['col-lg-3']}>
                  <OfferCard {...offer} />
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default CardsEntretenimento;